module.exports = __webpack_public_path__ + "static/green-bg-d036c4a6c8b1cb9b0107d1403abd6902.png";